import TagManager from 'react-gtm-module'

import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { ID } from 'src/Types/common'
import { Roles } from 'src/Constants/enums'

import { EventNameEnum, EventTypeEnum } from '../tagManagerEnums'

export const faqTiktokCreatingEvent = ({
  campaignType,
  userId,
  buttonType,
}: {
  campaignType: CampaignTypeEnum
  userId?: ID | null
  buttonType: string
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,
      event_params: {
        event_name: EventNameEnum.FAQTiktokCreating,
        campaign_platform: CampaignPlatformTypeEnum.TIKTOK,
        campaign_type: userId ? campaignType : CampaignTypeEnum.FIRST,
        button_type: buttonType,
      },
      user_properties: {
        ...(userId ? { user_ID: userId } : {}),
        account_type: Roles.artist,
      },
    },
  })
}

export const faqTiktokCreatingAnotherQuestionEvent = ({
  campaignType,
  userId,
}: {
  campaignType: CampaignTypeEnum
  userId?: ID | null
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,
      event_params: {
        event_name: EventNameEnum.FAQTiktokCreatingAnotherQuestion,
        campaign_platform: CampaignPlatformTypeEnum.TIKTOK,
        campaign_type: userId ? campaignType : CampaignTypeEnum.FIRST,
      },
      user_properties: {
        ...(userId ? { user_ID: userId } : {}),
        account_type: Roles.artist,
      },
    },
  })
}
